/* eslint-disable no-console */
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React, {useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';

import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import ReportChart from '../../../module/profile/reportChart';
import useDeleteMyAdvertisment from '../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';

import {useQueryClient} from 'react-query';
import DotsLoading from '../../../components/dotsLoading';
import Alert from '../../../components/mazraeKit/alert';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../components/SpinnerLoading';
import useGetAdvertisementDetail from '../../../services/hookService/getAdvertisementRequirementDetail/useGetAdvertisementRequirementDetail';
import useGetAllNotifications from '../../../services/hookService/getAllNotification/useGetAllNotifications';
import useGetUserPromotedAdverstisment from '../../../services/hookService/my-account/getUserPromotedAdverstisment/useGetUserPromotedAdverstisment';
import usePatchUserPromotedAdvertisement from '../../../services/hookService/my-account/patchUserPromotedAdvertisement/usePatchUserPromotedAdvertisement';
import usePostExtend from '../../../services/hookService/postExtend/usePostExtendAdvertisement';
import {clearAllData} from '../../../store/redux/addPictureAdvertisment';
import {
  addRegisterAdvertisement,
  resetAllAdvertisementData,
} from '../../../store/redux/advertisementRegisteration';
import {getPersianDateTimeV2} from '../../../utilities/helper/GetPersianDateTime';
import {
  isCloseToExpire,
  isExpired,
} from '../../../utilities/helper/isCloseToExpire';
import CountDown from './countDown';
import DeleteAdverTisment from './deleteAdverTisment';
import ExpireNotification from './expireNotification';
import HeaderCard from './headerCard';
import {descriptionHelper} from './helper';

interface DeleteBotoomSheetData {
  guid: string;
  title: string;
}
export interface DeleteBotoomSheet {
  isOpen: boolean;
  data: null | DeleteBotoomSheetData;
}

export interface ILocationState {
  type: 'advertisement' | 'requirement';
  requirement_type?: string;
  advertisement_type?: string;
  from?: string;
  returnState?: ILocationState | null;
}

const AdvertismentDetail = () => {
  const {guid} = useParams();
  const {state: adState, pathname} = useLocation();
  const LocationState = adState as ILocationState | null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const {refetch: refetchAdNotificatons} = useGetAllNotifications();
  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });

  const isAdRequirement = LocationState?.type === 'requirement';

  const {advertisementDetail: cardData, isLoading: cardIsLoading} =
    useGetAdvertisementDetail({
      guid: guid,
      advertisement_type: isAdRequirement
        ? LocationState?.requirement_type
        : LocationState?.advertisement_type,
      type: LocationState?.type,
    });

  const {mutate: extendAdvertisement, isLoading} = usePostExtend();

  const handleBack = () => {
    if (LocationState?.from) {
      navigate(LocationState.from);
      return;
    }

    navigate(-1);
  };
  const isExpiredAd = useMemo(() => {
    let expiredFlag = false;
    if (cardData?.expires_at) expiredFlag = isExpired(cardData.expires_at);
    if (cardData?.status === 'expired') expiredFlag = true;
    return expiredFlag;
  }, [cardData]);

  const manageList = [
    {
      className: 'text-gray-900',
      hide: isAdRequirement,
      icon: 'icon-nameBar-chart-upward',
      label: 'ارتقا آگهی',
      disabled: isExpiredAd,
      action: () => {
        navigate(`/upgrade/advertisement/account/${guid}`);
      },
    },
    {
      className: 'text-gray-900',
      icon: 'icon-nameEdit',
      label: 'ویرایش آگهی',
      disabled: isExpiredAd,
      action: () => {
        dispatch(resetAllAdvertisementData());
        navigate(
          `/edit/advertisment/${guid}/${
            isAdRequirement
              ? cardData?.requirement_type ?? LocationState?.requirement_type
              : cardData?.advertisement_type ??
                LocationState?.advertisement_type
          }`,
          {
            state: {
              type: isAdRequirement ? 'requirement' : 'advertisement',
              from: pathname,
            },
          },
        );

        dispatch(clearAllData());
        dispatch(
          addRegisterAdvertisement({
            ad_type: {
              title: 'آگهی شخصی',
              value: 'personal',
            },
          }),
        );
      },
    },
    {
      className: 'text-red-500',
      icon: 'icon-nameDelete',
      label: 'حذف آگهی',
      disabled: false,
      action: () => {
        setDeleteItem({isOpen: true, data: {guid: guid || '', title: ''}});
      },
    },
  ];

  const {mutate} = useDeleteMyAdvertisment({
    filter: isAdRequirement ? 'requirement' : 'advertisement',
    refetch: () => {
      queryClient.invalidateQueries({
        queryKey: ['get-all-notifications'],
      });
      refetchAdNotificatons();
      setDeleteItem({isOpen: false, data: null});
      navigate('/my-ads');
    },
  });

  const {
    UserPromotedAdverstismentData,
    UserPromotedAdverstismentIsLoading,
    refetch,
  } = useGetUserPromotedAdverstisment({guid});
  const {PatchUserPromotedAdvertisementMutate} =
    usePatchUserPromotedAdvertisement({
      onSuccess() {
        refetch();
      },
    });

  const handleExpireButtonNavigation = () => {
    navigate(
      `/edit/advertisment/${guid}/${
        isAdRequirement
          ? cardData?.requirement_type ?? LocationState?.requirement_type
          : cardData?.advertisement_type ?? LocationState?.advertisement_type
      }`,
      {
        state: {status: 'expired', from: pathname},
      },
    );
  };

  return (
    <div className="flex flex-col justify-between w-full h-full">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="مدیریت آگهی"
        isActiveRightIcon={true}
        onClick={() => navigate(-1)}
      />

      <div className="overflow-y-scroll flex-col gap-3 px-3 pb-2 w-full h-full d-flex">
        {cardData?.published_date &&
          (!isExpiredAd ? (
            isCloseToExpire(cardData?.expires_at, cardData?.published_date) && (
              <div className="flex flex-col gap-1 px-4 py-3 mt-3 text-sm text-orange-700 bg-amber-50 rounded-lg">
                <span>
                  این آگهی در تاریخ
                  {' ' +
                    getPersianDateTimeV2(new Date(cardData.expires_at ?? '')) +
                    ' '}
                  منقضی می‌شود. برای ادامه انتشار، آگهی را تمدید کنید.
                </span>
                <button
                  className="flex flex-1 justify-center items-center self-end px-3 py-2 text-sm font-medium text-white bg-amber-600 rounded-lg transition-colors outline-none w-fit"
                  onClick={() => {
                    if (cardData?.id && LocationState?.type)
                      extendAdvertisement({
                        advertisement_id: cardData?.id,
                        type: LocationState?.type,
                      });
                  }}
                >
                  {isLoading ? (
                    <SpinnerLoading
                      size={10}
                      className="flex flex-1 justify-center items-center self-end px-4 py-1 text-sm font-medium text-white rounded-lg transition-colors outline-none w-fit"
                    />
                  ) : (
                    <span>تمدید آگهی</span>
                  )}
                </button>
              </div>
            )
          ) : (
            <div className="flex flex-col gap-1 px-4 py-3 mt-3 text-sm text-red-700 bg-red-50 rounded-lg">
              <span>
                این آگهی در تاریخ
                {' ' +
                  getPersianDateTimeV2(new Date(cardData.expires_at ?? '')) +
                  ' '}
                منقضی شده است. برای انتشار مجدد، آگهی را تمدید کنید.
              </span>
              <button
                className="flex flex-1 justify-center items-center self-end px-3 py-2 text-sm font-medium text-white bg-red-600 rounded-lg transition-colors outline-none w-fit"
                onClick={() => {
                  if (cardData?.id && LocationState?.type)
                    extendAdvertisement({
                      advertisement_id: cardData?.id,
                      type: LocationState?.type,
                    });
                }}
              >
                {isLoading ? (
                  <SpinnerLoading
                    size={10}
                    className="flex flex-1 justify-center items-center self-end px-4 py-1 text-sm font-medium text-white rounded-lg transition-colors outline-none w-fit"
                  />
                ) : (
                  <span>تمدید آگهی</span>
                )}
              </button>
            </div>
          ))}

        {cardIsLoading ? (
          <div className="flex justify-center pt-4 w-full">
            <DotsLoading />
          </div>
        ) : (
          <HeaderCard data={cardData} />
        )}
        {UserPromotedAdverstismentIsLoading ? (
          <DotsLoading />
        ) : (
          <>
            {isExpiredAd && (
              <Alert
                colorPallete={{
                  borderColor: 'border-warning-500',
                  backgroundColor: 'bg-warning-50',
                  iconColor: 'text-warning-500',
                }}
                description={<>می‌توانید آگهی را یک بار دیگر منتشر کنید.</>}
                icon="icon-namereport-2"
                label={'آگهی منقضی شده است.'}
              />
            )}
            {UserPromotedAdverstismentData &&
              cardData?.title &&
              UserPromotedAdverstismentData?.length > 0 &&
              UserPromotedAdverstismentData.filter(
                item => !item.promote.expirable,
              ).map(item => (
                <Alert
                  key={item.guid}
                  colorPallete={{
                    borderColor: 'border-green-500',
                    backgroundColor: 'bg-green-50',
                    iconColor: 'text-green-600',
                  }}
                  description={
                    descriptionHelper(
                      item.promote.title,
                      cardData?.title,
                      item,
                    ) || ''
                  }
                  icon="icon-nameCheck-circle"
                  label={item.promote.title}
                  closeAction={() =>
                    PatchUserPromotedAdvertisementMutate(item.guid)
                  }
                />
              ))}
            {UserPromotedAdverstismentData &&
              UserPromotedAdverstismentData?.length > 0 &&
              UserPromotedAdverstismentData.filter(
                item => item.is_expired && item.promote.expirable,
              ).length > 0 && (
                <ExpireNotification
                  type="advertisement"
                  expireList={UserPromotedAdverstismentData.filter(
                    item => item.is_expired && item.promote.expirable,
                  ).map(item => {
                    return {
                      label: item.promote.title,
                      guid: item.promote.guid,
                    };
                  })}
                />
              )}
            {UserPromotedAdverstismentData &&
              UserPromotedAdverstismentData?.length > 0 &&
              UserPromotedAdverstismentData.filter(
                item => !item.is_expired && item.promote.expirable,
              ).map(item => {
                return (
                  <CountDown
                    key={item.guid}
                    dateTime={item.expire_date}
                    label={item.promote.title}
                    description={item.promote.description}
                  />
                );
              })}
          </>
        )}

        {guid && !isAdRequirement && <ReportChart guid={guid} />}
        <div className="flex flex-col w-full">
          {manageList.map((item, index) =>
            item.hide ? null : (
              <React.Fragment key={index}>
                <div className="d-flex h-[56px] w-full justify-between items-center px-2 no-underline text-inherit">
                  <div
                    className={classNames(
                      'text-md gap-2 flex items-center font-Regular',
                      item.className,
                      {
                        '!text-gray-200': item.disabled,
                        'text-gray-900 ': !item.disabled,
                      },
                    )}
                  >
                    <SpanIcon className={classNames('text-xl', item.icon)} />
                    <div>{item.label}</div>
                  </div>

                  <button
                    aria-label={item.label}
                    disabled={item.disabled}
                    onClick={() => !item.disabled && item.action()}
                  >
                    <SpanIcon
                      className={classNames(
                        'icon-nameArrow---Left-2 text-xxl',
                        {
                          'text-gray-200': item.disabled,
                          'text-gray-900 ': !item.disabled,
                          [item.className]: item.icon === 'icon-nameDelete',
                        },
                      )}
                    />
                  </button>
                </div>

                <div className="border-[1px] border-gray-200 flex w-full h-[1px]" />
              </React.Fragment>
            ),
          )}

          {isExpiredAd && (
            <button
              className="flex items-center justify-center border-[1px] text-md font-Medium border-farm-shop-500 pt-2 text-farm-shop-500 w-full h-[48px] rounded-[8px] mt-4"
              onClick={() => handleExpireButtonNavigation()}
            >
              ثبت مجدد آگهی
            </button>
          )}
        </div>

        <DeleteAdverTisment
          mutateFunction={() => {
            deleteItem.data?.guid && mutate(deleteItem.data?.guid);
          }}
          setDeleteItem={setDeleteItem}
          deleteItem={deleteItem}
        />
      </div>
      <MainFooter />
    </div>
  );
};

export default AdvertismentDetail;
